import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom';
import { authenticateUser } from "../../../redux/actions/authenticate";


const SecureRoute = (props) => {
    const { authenticateUser, children,
        ...rest } = props;

    useEffect(() => {
        // validate user token and refreshToken present or not in cookies
        props.authedicate()
    }, [])

    return (
        <>
            <Route {...rest}>
                {children}
            </Route>

        </>
    )
}

const mapStateToProps = (state) => ({
    //authenticateUser: state.authenticateUser,
})

const mapDispatchToProps = (dispatch) => ({
    authedicate: () => dispatch(authenticateUser()),

})

export default connect(mapStateToProps, mapDispatchToProps)(SecureRoute)